import axios from "axios";
import { apiEndpoint } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

/**
 * Which inductions a property requires.
 *
 * Owner/admin configuration, separate from visitorInduction.service.js, which
 * runs an induction and is open to any property member. Same
 * `{ success, data, message }` envelope.
 */
export const inductionRequirementService = {
  getList,
  create,
  update,
  remove,
};

const unwrap = (res) => (res && res.status === 200 ? res.data : null);

function getList(propertyId) {
  return axios
    .get(apiEndpoint.propertyInductionRequirement, {
      headers: authHeader(),
      params: { property_id: propertyId },
    })
    .then(unwrap);
}

function create({ propertyId, formId, visitorType, sortOrder }) {
  return axios
    .post(
      apiEndpoint.propertyInductionRequirement,
      {
        property_id: propertyId,
        form_id: formId,
        // null means the requirement applies to every visitor type.
        visitor_type: visitorType || null,
        sort_order: sortOrder || 0,
      },
      { headers: authHeader() }
    )
    .then(unwrap);
}

function update(id, attrs) {
  return axios
    .put(`${apiEndpoint.propertyInductionRequirement}/${id}`, attrs, {
      headers: authHeader(),
    })
    .then(unwrap);
}

function remove(id) {
  return axios
    .delete(`${apiEndpoint.propertyInductionRequirement}/${id}`, {
      headers: authHeader(),
    })
    .then(unwrap);
}
